// Keep distinct groups even when their display names match. An empty optional
// group has no choice to offer; mandatory groups must still enforce selection.
export const visibleItemGroups = (groups = []) => groups.map(group => ({
  ...group,
  items: (group.items || []).filter(item => typeof item.name === "string" && item.name.trim() !== ""),
})).filter(group => group.mandatory || group.items.length > 0);
